import { Constants } from '@pwc/pwc-deals-web-common';
import { cloneDeep } from 'lodash';
import { layoutTypeToDroppableLocationIdMap } from './generateDroppableLocationSetForSection';

const isTextBox = (libraryItem) =>
  libraryItem.type === Constants.LIBRARY_ITEM_TYPES.RICH_TEXT.value;

const isTextOverflowSection = (type) =>
  type === Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_OVERFLOW_AREA;

const canLibraryItemBePlacedInSection = (libraryItem, sectionLayoutType) => {
  if (!isTextBox(libraryItem) && isTextOverflowSection(sectionLayoutType)) {
    return false;
  }
  return true;
};

const generateLayoutTypeChangeHandler = (
  index,
  currentSections,
  setDroppableLocations,
  setCurrentSections,
  nonLaidOutLibraryItems,
  editNonLaidOutLibraryItems
) => {
  const section = currentSections[index];
  let newSection;
  return (type) => {
    newSection = {
      ...section,
      layoutType: type,
      items: [],
    };
    const droppableLocations = layoutTypeToDroppableLocationIdMap[type];
    const clonedSectionItems = section.items.map((item) => {
      const cloned = cloneDeep(item);
      const newAnalysisColumn =
        item.analysisColumn <= droppableLocations.length &&
        canLibraryItemBePlacedInSection(item, type)
          ? item.analysisColumn
          : null;
      if (newAnalysisColumn) {
        cloned.analysisColumn = newAnalysisColumn;
      } else {
        delete cloned.analysisColumn;
      }
      return cloned;
    });
    const removedSectionItems = clonedSectionItems.filter(
      (item) => !item.analysisColumn
    );
    const currentSectionItems = clonedSectionItems.filter(
      (item) => item.analysisColumn
    );
    newSection.items = [...currentSectionItems];

    editNonLaidOutLibraryItems([
      ...nonLaidOutLibraryItems,
      ...removedSectionItems,
    ]);

    const newSections = cloneDeep(currentSections);
    newSections[index] = newSection;
    setCurrentSections(newSections);
  };
};

export default generateLayoutTypeChangeHandler;
